import i18n from '../i18n';

/** 后端 AI / 风控分析接口支持的 language 枚举（与 Apifox 一致） */
export type ApiLanguageCode = 'CN' | 'EN' | 'IT' | 'SP';

/** 后端可识别的语言码白名单 */
const API_LANGUAGE_CODES: ApiLanguageCode[] = ['CN', 'EN', 'IT', 'SP'];

/**
 * 将当前 i18n 语言映射为后端 API `language` 参数。
 * @returns CN / EN / IT / SP；无法识别时回退 EN
 */
export function getApiLanguageCode(): ApiLanguageCode {
  /** 当前界面语言（与 i18n.resources 键一致，如 CN、EN） */
  const raw = (i18n.language || 'EN').toUpperCase();
  if (API_LANGUAGE_CODES.includes(raw as ApiLanguageCode)) {
    return raw as ApiLanguageCode;
  }
  return 'EN';
}
